<template>
<svg xmlns="http://www.w3.org/2000/svg" :fill="useCurrentColor ? 'currentColor' : '#000'" viewBox="0 0 14 14" :class="[`${prefix}-icon`, `${prefix}-icon-add3`]" width="1em" height="1em" v-bind="$attrs"><defs><clipPath id="svg_1954147b65__a"><rect width="14" height="14" rx="0"/></clipPath></defs><g clip-path="url(#svg_1954147b65__a)"><path d="M12.25,0L1.75,0C0.7875,0,0,0.7875,0,1.75L0,12.25C0,13.2125,0.7875,14,1.75,14L12.25,14C13.2125,14,14,13.2125,14,12.25L14,1.75C14,0.7875,13.2125,0,12.25,0ZM7.4375,6.51875L9.8,6.51875C10.0625,6.51875,10.3687,6.78125,10.3687,7.04375C10.3687,7.30625,10.15,7.525,9.8875,7.525L7.525,7.525L7.525,9.8875C7.525,10.15,7.30625,10.3687,7.04375,10.3687C6.78125,10.3687,6.5625,10.15,6.5625,9.8875L6.5625,7.525L4.2,7.525C3.9375,7.525,3.71875,7.30625,3.71875,7.04375C3.71875,6.78125,3.9375,6.5625,4.2,6.5625L6.475,6.5625L6.475,4.2C6.475,3.9375,6.69375,3.71875,6.95625,3.71875C7.21875,3.71875,7.4375,3.9375,7.4375,4.2L7.4375,6.51875Z" fill-rule="evenodd"/></g></svg>
</template>
<script>

export default {
  name: 'IconAdd3',
  props: {
    prefix: {
        type: String,
        default: 'cmstopgpt',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
